import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function Unlock(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: Pre.DOORLOCK + Actions.UNLOCK,
    accessToken,
    payload: { deviceId, deviceUId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function Lock(deviceId = 0, deviceUId = null, accessToken) {
  return {
    type: Pre.DOORLOCK + Actions.LOCK,
    accessToken,
    payload: { deviceId, deviceUId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function resetAskToOpenDataLocally() {
  return {
    type: Pre.DOORLOCK + Actions.RESET_ASK_TO_OPEN,
    payload: {},
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
